export default __webpack_public_path__ + "static/2-b3dbea444b00b8ea29b76080e40078c6.webp";